import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import RequisitionGrid from './requisitionGrid';
import AuthorizationGrid from './authorization';
import MessageGrid from './messageGrid';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearRows } from '../../../Redux/actions/rowActions';
import { ClipLoader } from 'react-spinners';
import { getUserId, getName, getUserName, getCompany } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { FaAngleLeft } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import Attachment from '../Attachment/attachment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import UpdateAttachment from '../Attachment/UpdateAttachment';



const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});

const PurchaseRequisitionUpdate = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const { currencyPrecision } = useCurrency();
    const [messageData, setMessageData] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [department, setDepartment] = useState([]);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [Location, setLocation] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [usersDetails, setUser] = useState([]);
    const [loader, setLoader] = useState(false);
    const [deliveryPoint, setDeliveryPoint] = useState();
    const [selLocation, setSelLocation] = useState();
    const [contactPerson, setContactPerson] = useState();
    let navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const itemData = location.state;
    const userName = useSelector(getUserName);
    const [ReqNo, setReqNo] = useState([]);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [preview, setPreview] = useState();
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const closeModal = () => setAttachmentModal(false);
    const isReadOnly = itemData?.eye === true;
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [formData, setFormData] = useState({
        recordId: "",
        requisitionNo: "",
        itemType: "",
        quatotionNo: "",
        remarks: "",
        requestor: "",
        requisitionDate: getCurrentLocalDatetime(),
        deliveryDate: getCurrentLocalDatetime(),
        currencyCode: "",
        exchangeRate: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        location: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
    });
    useEffect(() => {
        getCurrency()
    }, []);

    useEffect(() => {
        const item = location.state;
        const getAttachment = async () => {
            let wareHouseRes = await apiService.get('GET_WAREHOUSE_MASTER')
            setLocation(wareHouseRes.data.result);
            const selectedLocation = wareHouseRes?.data?.result?.find(dep => dep.description === item?.approvalUser)
            if (selectedLocation) {
                setSelectedLocation({ label: selectedLocation.description, value: selectedLocation })
            }
            let DepRes = await apiService.getApiParamater('GET_DEPARTMENT_MASTER', param)
            setDepartment([{ value: null, description: 'None' }, ...DepRes.data.result]);
            const selectedDepartment = DepRes?.data?.result?.find(dep => dep.description === item?.department)
            if (selectedDepartment) {
                setSelectedDepartment({ label: selectedDepartment.description, value: selectedDepartment })
            }
            let cost1 = await apiService.get('GET_COST_ONE')
            setCost1([{ value: null, description: 'None' }, ...cost1.data.result]);
            const costCenter1 = cost1?.data?.result?.find(dep => dep.description === item?.costCenter1)
            let cost2 = await apiService.get('GET_COST_TWO')
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
            const costCenter2 = cost2?.data?.result?.find(dep => dep.description === item?.costCenter2)
            let cost3 = await apiService.get('GET_COST_THREE')
            setCost3(cost3?.data?.result || []);
            const costCenter3 = cost3?.data?.result?.find(dep => dep.description === item?.costCenter3)
            let cost4 = await apiService.get('GET_COST_FOUR')
            setCost4(cost4?.data?.result || []);
            const costCenter4 = cost4?.data?.result?.find(dep => dep.description === item?.costCenter4)
            setFormData({
                recordId: item?.recordId,
                requisitionDate: item?.requisitionDate,
                deliveryDate: item?.deliveryDate,
                requisitionNo: item?.requisitionNo,
                quatotionNo: item?.contractNo,
                remarks: item?.remarks,
                requestor: item?.requestor,
                currencyCode: item?.currencyCode,
                itemType: { label: item?.type, value: item?.type },
                costCenter1: { label: costCenter1?.description, value: costCenter1 },
                costCenter2: { label: costCenter2?.description, value: costCenter2 },
                costCenter3: { label: costCenter3?.description, value: costCenter3 },
                costCenter4: { label: costCenter4?.description, value: costCenter4 },
                contatNo: item?.contatNo,
                taskCode: item?.projectCode,
            });
            setDeliveryPoint(item?.deliveryPoint)
            setSelLocation(item?.location)
            setContactPerson(item?.contactPerson)
            let attachparam = `?DocNo=${itemData.requisitionNo}&DocType=${"Requisition"}`;
            const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
            const existingAttachments = AttachmentResponse?.data?.result || [];
            if (existingAttachments) {
                setAttachments(mapAttachmentsFromApi(existingAttachments));
            }
        }
        if (item) {
            getAttachment()
        }

    }, [location?.state]);

    let param = `?isActive=true`

    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };
    const getCurrency = async () => {
        setReqNo(itemData.requisitionNo);
        const params = new URLSearchParams();
        params.append('DocNo', itemData.requisitionNo);
        params.append('DocumentType', "Purchase Requisition");
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
        setFormData({ ...formData, exchangeRate: currencyPrecision.conversionRate });
        setFormData({ ...formData, exchangeRate: currencyPrecision.conversionRate });
        if (currencyPrecision) {
            setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')
    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const staticOptions = [];
    const itemType = [
        { value: 'None', label: 'None' },
        { value: 'Inventory', label: 'Inventory' },
        { value: 'Fixed Asset', label: 'Fixed Asset' },
        { value: 'Services', label: 'Services' },
    ];
    const totalAmount = requisitionData.reduce((sum, row) => sum + (row?.qty * row.baseAmount || 0), 0);
    const UpdatePR = async () => {
        try {
            setLoader(true)
            for (const item of requisitionData) {
                if (!item.itemDescription) {
                    toast.warning(`Please Select Item`);
                    setLoader(false);
                    return;
                } else if (!item.qty) {
                    toast.warning(`Please enter ${item.itemDescription} quantity`);
                    setLoader(false);
                    return;
                } else if (item.qty === "0") {
                    toast.warning(`${item.itemDescription} quantity must be greater then 0`);
                    setLoader(false);
                    return;
                }
            }
            const prDetailsData = requisitionData?.map((item, index) => ({
                requisitionNo: ReqNo,
                srno: index + 1,
                itemCode: item?.itemNo,
                itemDescription: item.itemDescription,
                specification: item.specification,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.qty),
                convValue: 1,
                unitPrice: Number(item.baseAmount).toFixed(currencyPrecision?.exp1 || 2),
                amount: Number(item.amount).toFixed(currencyPrecision?.exp1 || 2),
                baseAmount: Number(item.amount).toFixed(currencyPrecision?.exp1 || 2)
            }));

            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                requisitionNo: ReqNo,
                type: "Inventory",
                reqType: "Purchase Requisition",
                contractNo: formData?.quatotionNo,
                description: formData?.description,
                requestor: formData?.requestor,
                requisitionDate: currentDatetimeUTC,
                deliveryDate: formData.deliveryDate,
                currencyCode: formData?.currencyCode,
                exchangeRate: formData?.exchangeRate,
                department: selectedDepartment?.value?.description,
                remarks: formData?.remarks,
                costCenter1: formData.costCenter1?.label,
                costCenter2: formData.costCenter2?.label,
                costCenter3: formData.costCenter3?.label,
                costCenter4: formData.costCenter4?.label,
                deliveryPoint: deliveryPoint,
                location: selLocation,
                contactPerson: contactPerson,
                contatNo: formData?.contatNo,
                projectCode: formData?.taskCode,
                prDetails: prDetailsData,
                modifiedBy: userName,
                baseAmount: Number(totalAmount).toFixed(currencyPrecision?.exp1 || 2),
                amount: Number(totalAmount).toFixed(currencyPrecision?.exp1 || 2),
                status: 0,
                approvalUser: selectedLocation?.label,
            };
            const response = await apiService.put("UPDATE_PR", userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "Purchase Requisition",
                    docId: ReqNo,
                    status: 0,
                    remarks: formData?.remarks,
                };
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                if (attachments) {
                    let name = "Requisition"
                    let docNo = ReqNo
                    handleUpload(name, docNo)
                }
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Purchase Requisition");
                paramsGet.append('docId', ReqNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "Purchase Requisition",
                        body: "",
                        docNo: ReqNo,
                        srNo: 1,
                        docType: "Purchase Requisition"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }

                handleReset()
                toast.success(`${ReqNo} Update successfully`);
                navigate("/Inventory/Requisition/Listing")
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if ((name === 'contatNo') && value.length > 16) {
            return;
        }
        if (name === 'requisitionDate' || name === 'deliveryDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        if ((name === "contatNo") && value < 0) {
            return;
        }
        if (name === 'deliveryPoint') {
            setDeliveryPoint(e.target.value);
            return;
        }
        if (name === 'location') {
            setSelLocation(e.target.value);
            return;
        }
        if (name === 'contactPerson') {
            setContactPerson(e.target.value);
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });

    };
    const handleDepChange = (selectedOption) => {
        setSelectedDepartment(selectedOption)
    };
    const handleItemTypeChange = (selectedOption) => {
        setFormData({ ...formData, itemType: selectedOption });
    };
    const handlelocChange = (selectedOption) => {
        setSelectedLocation(selectedOption)
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleCost1 = (selectedOption) => {
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }
    const handleReset = () => {
        setLoader(false)
        setFormData({
            itemType: "",
            quatotionNo: "",
            remarks: "",
            requestor: "",
            currencyCode: "",
            department: "",
            costCenter1: "",
            costCenter2: "",
            costCenter3: "",
            costCenter4: "",
            deliveryPoint: "",
            contatNo: "",
            taskCode: "",
        });
        dispatch(clearRows());
        setSelectedDepartment([])
        setSelectedLocation([])
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    // Attachment Functions
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {
        debugger
        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();
        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {

            const uploadedFileNames = response.data.result.split(",");
            let uploadedIndex = 0;

            const payload = {
                docFilesDtos: attachments
                    .filter(a => {
                        //  skip deleted
                        if (a.isDeleted === true) return false;

                        //  keep old files
                        if (a.fileName && a.fileName.trim()) return true;

                        //  keep new uploads only if file exists
                        if (a.isNew && a.file) return true;

                        //  skip empty rows
                        return false;
                    })
                    .map((a, index) => {

                        let fileName = a.fileName?.trim();

                        // 🔁 Assign uploaded filename ONLY to new attachments
                        if (!fileName && a.isNew) {
                            fileName = uploadedFileNames[uploadedIndex]?.trim();
                            uploadedIndex++;
                        }
                        return {
                            rcno: a?.dbId,
                            srno: index + 1,
                            docNo: docNo,
                            docType: name,
                            fileName,
                            remarks: a.remarks || "",
                        };
                    }),
                docNo: docNo,
            };

            await apiService.put("UPDATE_ATTACHMENT", payload);
        }

    };
    return (
        <div className='p-4'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Purchase Requisition</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div className='col center'>
                        {loader === true ?
                            <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <button className='mainbtn ' onClick={UpdatePR} type="submit">
                                <FaSave className='center mt-1 mx-2' /> <div>Update</div>
                            </button>
                        }
                    </div>
                    {itemData?.eye === true ? " " :
                        <button className='mainbtnRed' onClick={() => handleReset()}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    }
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Requisition Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="ReqNo" className="form-label  pt-2 start">Requisition No</label>
                                <input
                                    className="form-Input w-70"
                                    disabled
                                    value={ReqNo}
                                    name="ReqNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Delivery Date</label>
                                <input
                                    className='form-Input w-70'
                                    type='datetime-local'
                                    value={formData.deliveryDate}
                                    name="deliveryDate"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Location *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={selectedLocation}
                                    onChange={(selectedOption) => handlelocChange(selectedOption)}
                                    options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requisitionDate" className="form-label  pt-2 start">Date </label>
                                <input
                                    className='form-Input w-70'
                                    type='datetime-local' disabled
                                    value={formData.requisitionDate}
                                    name="requisitionDate"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryPoint" className="form-label  pt-2 start">Delivery Point</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="deliveryPoint"
                                    value={deliveryPoint}
                                    onChange={handleInputChange}
                                    name="deliveryPoint"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Copy Request</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={staticOptions}
                                    onChange={(selectedOption) => handleInputChange('inventoryAccountCode', selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Currency</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isSearchable={false}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={SelectedCurrency}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="location" className="form-label  pt-2 start">Location</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="location"
                                    value={selLocation}
                                    onChange={handleInputChange}
                                    name="location"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Quotation No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0"
                                    options={staticOptions}
                                    onChange={(selectedOption) => handleInputChange('inventoryAccountCode', selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="exchangeRate" className="form-label  pt-2 start">Exchange Rate</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    disabled
                                    onWheel={(e) => e.target.blur()}
                                    id="exchangeRate"
                                    value={formData.exchangeRate}
                                    onChange={handleInputChange}
                                    name="exchangeRate"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Contact Person</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="contactPerson"
                                    value={contactPerson}
                                    onChange={handleInputChange}
                                    name="contactPerson"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requestor" className="form-label  pt-2 start">Requester</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="requestor"
                                    value={formData.requestor}
                                    onChange={handleInputChange}
                                    name="requestor"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Item Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    value={formData.itemType}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={itemType}
                                    onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contatNo" className="form-label  pt-2 start">Contact No</label>
                                <input
                                    type="number"
                                    className="form-Input w-70"
                                    id="contatNo"
                                    onWheel={(e) => e.target.blur()}
                                    value={formData.contatNo}
                                    onChange={handleInputChange}
                                    onKeyDown={preventNegativeSign}
                                    name="contatNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="selectedDepartment" className="form-label  pt-2 start">Department</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={selectedDepartment}
                                    options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                    onChange={(selectedOption) => handleDepChange(selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="department" className="form-label  pt-2 start">Task Code</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    defaultValue={formData.taskCode}
                                // onChange={handleDepChange}
                                // options={taskCode?.map((dep) => ({ value: dep, label: dep?.name }))}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input
                                    name="remarks"
                                    type='text'
                                    className="form-Input w-70"
                                    id="subcatname"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => setAttachmentModal(true)} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Cost Center</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row justify-content-between">
                            <div className="col-4   d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={formData.costCenter1}
                                    onChange={handleCost1}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0" value={formData.costCenter2}
                                    onChange={handleCost2}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0" value={formData.costCenter3}
                                    onChange={handleCost3}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-70 p-0" value={formData.costCenter4}
                                    onChange={handleCost4}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`cost-center-section`}>
                <div className="mt-3 cursor-pointer slide-header">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Requisition
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    {gridVisibility[0] && (
                        <RequisitionGrid onRequisitionData={handleRequisitionData} itemData={itemData} selectedLocation={selectedLocation} precision={currencyPrecision?.exp1} />
                    )}
                    {gridVisibility[1] && (
                        <AuthorizationGrid
                            handleAuthorization={handleAuthorization}
                            usersDetails={usersDetails}
                            setUser={setUser}
                            itemData={itemData}
                        />
                    )}
                    {gridVisibility[2] && (
                        <div className="grid-3 border">
                            <MessageGrid handleMessage={handleMessage} />
                        </div>
                    )}
                </div>
            </div>

            <div>
                <UpdateAttachment
                    open={attachmentModal}
                    rows={attachments}
                    documentNo={ReqNo}
                    readOnly={itemData?.eye}
                    onView={handleView}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    previewImage={previewImage}
                    previewOpen={previewModal}
                    preview={preview}
                    onClose={closeModal}
                    closePreview={() => setPreviewModal(false)}
                />

            </div>
        </div>
    )
}

export default PurchaseRequisitionUpdate